import { PaginationContext } from "./chunk-6MXG22MP.js";
import { Link_default } from "./chunk-WLZ2VL3G.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/Pagination/Pagination.Item.tsx
import { forwardRef, useContext, useCallback } from "react";
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var DEFAULT_COMPONENT = "a";
var PaginationItem = forwardRef((_a, ref) => {
  var _b = _a,
    {
      as,
      pageNumber,
      onClick,
      className
    } = _b,
    rest = __objRest(_b, ["as", "pageNumber", "onClick", "className"]);
  const Component = as || DEFAULT_COMPONENT;
  const {
    currentPage
  } = useContext(PaginationContext);
  const isCurrentPage = currentPage === pageNumber;
  const handleClick = useCallback(event => {
    onClick == null ? void 0 : onClick(pageNumber, event);
  }, [onClick, pageNumber]);
  return /* @__PURE__ */jsx("li", {
    children: /* @__PURE__ */jsx(Link_default, __spreadProps(__spreadValues({
      ref,
      as: Component
    }, rest), {
      variant: "secondary",
      onClick: handleClick,
      className: clsx(className, "pd-pagination__link", isCurrentPage && "pd-pagination__link--current"),
      "aria-current": isCurrentPage ? "page" : void 0,
      children: pageNumber
    }))
  });
});
var StoryPaginationItem = args => /* @__PURE__ */jsx(PaginationItem, __spreadValues({}, args));
var Pagination_Item_default = PaginationItem;
export { StoryPaginationItem, Pagination_Item_default };